import React, { useContext } from 'react';
import {
  StyleSheet, Animated, View, Platform,
} from 'react-native';

import { STATUS, DragAndDropContext } from '../contexts/DragAndDropContext';
import { DraggableFlatListContext } from '../contexts/DraggableFlatListContext';
import { ScrollViewContext } from '../contexts/ScrollViewContext';


const styles = StyleSheet.create({
  itemContainer: {
    flex: 1,
  },
  shadow: {
    flex: 1,
    backgroundColor: 'white',
    shadowColor: 'rgba(0,0,0,0.1)',
    shadowOffset: {
      width: 0,
      height: 3,
    },
  },
});

const interpolations = {
  opacity: {
    inputRange: [0, 0.5, 0.6, 1],
    outputRange: [1, 1, 0, 0],
  },
};

const DraggableFlatListRow = ({
  index,
  isDragged,
  item,
}) => {
  const {
          itemHeight,
          relativeY,
          headerComponentOffset,
          renderItem,
          scrollContentOffsetY,
        } = useContext(DraggableFlatListContext),
        {
          contentOffset,
        } = useContext(ScrollViewContext),
        {
          activeItemIndex,
          draggedAnimation,
          touchStatus,
          animatedDrag,
          statefulWebLongPress,
        } = useContext(DragAndDropContext);

  const opacity = animatedDrag
    && !isDragged && item
    && animatedDrag.item && item.id === animatedDrag.item.id
    ? draggedAnimation.interpolate(interpolations.opacity)
    : 1;

  const positionInScrollViewPre = Animated.add(Animated.add(
    relativeY,
    scrollContentOffsetY.current,
  ), new Animated.Value(-headerComponentOffset));

  const positionInScrollView = Platform.OS === 'web'
    ? Animated.add(positionInScrollViewPre, contentOffset.current.y)
    : positionInScrollViewPre;


  const shadowOpacity = isDragged ? 0.25 : 0.2,
        shadowRadius = isDragged ? 3 : 2;

  return (
    <Animated.View
      useNativeDriver
      className={statefulWebLongPress || touchStatus === STATUS.DRAGGED ? 'dragging' : 'draggable'}
      style={[
        styles.itemContainer,
        {
          minHeight: itemHeight,
          opacity,
        },
        {
          transform: activeItemIndex !== index && (touchStatus === STATUS.DRAGGED) ? [{
            translateY: positionInScrollView.interpolate({
              ...activeItemIndex > index
                ? {
                  inputRange: [(index + 1) * itemHeight, (index + 1.05) * itemHeight],
                  outputRange: [itemHeight * 1, 0],
                } : {
                  inputRange: [(index - 0) * itemHeight, (index + 0.05) * itemHeight],
                  outputRange: [0, -itemHeight * 1],
                },
              extrapolate: 'clamp',
            }),
          }] : [],
        }]}
    >
      <View
        elevation={isDragged ? 2 : 1}
        style={[styles.shadow, {
          shadowOpacity,
          shadowRadius,
        }]}
      >
        { renderItem({ item, index, isDragged }) }
      </View>
    </Animated.View>
  );
};

export const renderItem = ({ item, index }) => (
  <DraggableFlatListRow
    index={index}
    item={item}
  />
);

export default DraggableFlatListRow;
